import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BranchFilterService {
  menuChoosen$ = new Subject<number>();
  branchCreated$ = new Subject<number>();
  branchPinned$ = new Subject<number>();
  
  constructor() { }
}